import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { glassEffect } from '../../theme';

export const PageTitle = styled.h1` color: ${({ theme }) => theme.heading}; margin-bottom: 30px; `;
export const HeaderGrid = styled.div` display: grid; grid-template-columns: 1fr auto; align-items: center; gap: 20px; margin-bottom: 30px; `;

export const UploadButton = styled(Link)`
  display: flex; align-items: center; gap: 8px; padding: 10px 20px;
  background-color: ${({ theme }) => theme.primary}; color: white;
  border-radius: 8px; text-decoration: none; font-weight: 600;
`;

export const StatGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; `;

export const StatCard = styled.div`
  ${glassEffect}
  padding: 20px; border-radius: 12px;
`;

export const StatTitle = styled.h3` color: ${({ theme }) => theme.text}; font-size: 16px; margin-top: 0; margin-bottom: 10px; `;
export const StatValue = styled.p` color: ${({ theme }) => theme.heading}; font-size: 32px; font-weight: 600; margin: 0; `;